import { Grid, Typography } from '@material-ui/core';
import { useCompany, useCompanyFunctions } from 'contexts/CompanyContext';
import { useHistory } from 'react-router-dom';
import CompanyDetailsForm from 'components/CompanyDetailsForm';
import MaiaLogo from 'components/MaiaLogo';
import RegisterLayout from 'pages/RegisterLayout';
import routes from 'config/routes';
import sideImage from '_assets/register/register-description-image.svg';
import useStyles from './styles';

const RegisterDescription = () => {
  const classes = useStyles();
  const history = useHistory();

  const { currentCompany } = useCompany();
  const { editCompanyDetails } = useCompanyFunctions();

  const handleSubmit = async (values) => {
    const created = await editCompanyDetails(currentCompany, values);
    if (created) history.push(routes.home.root);
    return created;
  };

  const SideComponent = () => (
    <Grid container direction="column" style={{ height: 'auto' }}>
      <Grid container item justifyContent="center">
        <MaiaLogo />
      </Grid>

      <Grid container item justifyContent="center" style={{ marginTop: '8vh' }}>
        <img src={sideImage} alt="Surf" width={200} />
      </Grid>

      <Grid container item justifyContent="center" style={{ marginTop: '3vh' }}>
        <Typography className={classes.text} align="center" variant="h3">
          Il s’agit de la carte d’identité de votre entreprise.
        </Typography>
        <Typography className={classes.text} align="center" variant="h3" style={{ marginTop: '3vh' }}>
          Présentez ici qui vous êtes ce que vous faites.
        </Typography>
        <Typography className={classes.text} align="center" variant="h3" style={{ marginTop: '3vh' }}>
          Le client le verra quand il consultera votre page.
        </Typography>
        <Typography className={classes.text} align="center" variant="h3" style={{ marginTop: '3vh' }}>
          Si vous disposez d’une note Tripadvisor et/ou Google insérez le lien
        </Typography>
      </Grid>
    </Grid>
  );

  return (
    <RegisterLayout SideComponent={<SideComponent />}>
      <Grid container direction="column" style={{ height: 'auto' }}>
        <Grid className={classes.header} container item justifyContent="center" style={{ flexGrow: 0 }}>
          <Grid className={classes.title} container item xs={12} md={9} justifyContent="center">
            <Typography variant="h1">Présentation de l’entreprise</Typography>
          </Grid>
        </Grid>

        <Grid container item justifyContent="center" style={{ flexGrow: 1 }}>
          <Grid item xs={12} md={10}>
            <CompanyDetailsForm
              onCancel={() => {
                history.push(routes.home.root);
              }}
              onSubmit={handleSubmit}
            />
          </Grid>
        </Grid>
      </Grid>
    </RegisterLayout>
  );
};

export default RegisterDescription;
